import type { Translations } from './types';

export const de: Translations = {
  appName: 'NATO-Alphabet Trainer',
  converter: 'Konverter',
  quiz: 'Buchstaben-Quiz',
  wordQuiz: 'Wort-Quiz',
  settings: 'Einstellungen',
  enterText: 'Text zur Konvertierung eingeben',
  placeholder: 'Geben Sie hier Ihre Nachricht ein...',
  natoAlphabet: 'NATO-Alphabet',
  playPronunciation: 'Aussprache Abspielen',
  stop: 'Stoppen',
  quickReference: 'Schnellreferenz',
  showLess: 'Weniger Anzeigen',
  viewFullAlphabet: 'Vollständiges Alphabet Anzeigen →',
  copied: 'Kopiert!',
  copyFailed: 'Kopieren fehlgeschlagen',
  speechNotAvailable: 'Sprachsynthese nicht verfügbar',
  voiceSettings: 'Spracheinstellungen',
  textToSpeechVoice: 'Text-zu-Sprache Stimme',
  testVoice: 'Stimme Testen',
  notifications: 'Benachrichtigungen',
  spacedRepetitionReminders: 'Wiederholungserinnerungen',
  notificationDescription: 'Erhalten Sie tägliche Erinnerungen zum Üben',
  language: 'Sprache',
  interfaceLanguage: 'Oberflächensprache',
  about: 'Über NATO-Alphabet Trainer',
  question: 'Frage',
  questionCount: '{current} von {total}',
  reviewYourAnswers: 'Überprüfen Sie Ihre Antworten',
  typeNatoWordForLetter:
    'Geben Sie das NATO-Wort für den Buchstaben {letter} ein',
  startVoiceInput: 'Spracheingabe starten',
  stopVoiceInput: 'Spracheingabe stoppen',
  aboutDescription:
    'Lernen Sie das NATO-Phonetik-Alphabet durch interaktive Quiz und wiederholtes Lernen.',
  version: 'Version 1.0.0',
  builtWith: 'Mit modernen Web-Technologien erstellt',
  currentStreak: 'Aktuelle Serie',
  totalSessions: 'Gesamte Sitzungen',
  accuracy: 'Genauigkeit',
  learningProgress: 'Lernfortschritt',
  startQuiz: 'Quiz Starten',
  restartQuiz: 'Quiz Neustarten',
  nextQuestion: 'Nächste Frage',
  submitAnswer: 'Antwort Senden',
  showStats: 'Statistiken Anzeigen',
  hideStats: 'Statistiken Verbergen',
  correctAnswer: 'Richtige Antwort',
  yourAnswer: 'Ihre Antwort',
  correct: 'Richtig',
  incorrect: 'Falsch',
  sessionComplete: 'Sitzung Abgeschlossen!',
  score: 'Punkte',
  tryAgain: 'Erneut Versuchen',
  hint: 'Hinweis',
  femaleVoice: 'Weibliche Stimme',
  maleVoice: 'Männliche Stimme',
  robotVoice: 'Roboterstimme',
  dailyReminders:
    'Sie erhalten tägliche Erinnerungen zum Üben des NATO-Alphabets basierend auf Ihrem Lernfortschritt.',
  speakAnswer: 'Sprechen Sie Ihre Antwort',
  voiceInputActive: 'Zuhören...',
  adaptiveLearning: 'Adaptives Lernen',
  skipQuestion: 'Überspringen',
  pressEnterToSubmit: 'Drücken Sie Enter zum Senden',
  pressEscapeToSkip: 'Drücken Sie Escape zum Überspringen',
  exampleAnswers: 'z.B. alpha, bravo, charlie',
  notificationsPanelTitle: 'Benachrichtigungen',
  markAllAsRead: 'Alle als gelesen markieren',
  noNotifications: 'Keine Benachrichtigungen',
  natoHints: {
    A: 'Erster Buchstabe des griechischen Alphabets',
    B: 'Gut gemacht, Applaus!',
    C: 'Phonetisches C, wie der Name',
    D: 'Dreieckige Flussformation',
    E: 'Schallreflexion',
    F: 'Gesellschaftstanz',
    G: 'Sport mit Schlägern und Löchern',
    H: 'Ort zum Übernachten',
    I: 'Großes asiatisches Land',
    J: 'Shakespeare-Heldin',
    K: 'Gewichtseinheit (1000 Gramm)',
    L: 'Hauptstadt von Peru',
    M: 'Abkürzung für Mikrofon',
    N: 'Herbstmonat',
    O: 'Akademie-Preis',
    P: 'Vater, umgangssprachlich',
    Q: 'Kanadische Provinz',
    R: 'Shakespeare-Figur',
    S: 'Gebirgskette',
    T: 'Argentinischer Tanz',
    U: 'Gleiche Kleidung für alle',
    V: 'Gewinner, Champion',
    W: 'Starkes alkoholisches Getränk',
    X: 'Medizinische Bildgebung',
    Y: 'Amerikanischer Baseballspieler',
    Z: 'Afrikanische Kriegernation',
  },
  // Quiz specific
  learning: 'Lernen',
  review: 'Wiederholen',
  mastered: 'Beherrscht',
  lastFiveTimes: 'Letzte 5 Quiz-Zeiten',
  quizTimes: 'Quiz-Zeiten',
  bestTime: 'Beste Zeit',
  noTimesRecorded: 'Keine Zeiten Aufgezeichnet',
  // Settings
  theme: 'Thema',
  lightTheme: 'Hell',
  darkTheme: 'Dunkel',
  rainbowTheme: 'Regenbogen',
  systemTheme: 'System',
  appearance: 'Erscheinungsbild',
  chooseTheme: 'Wählen Sie Ihr bevorzugtes Thema',
  spacedRepetitionDescription:
    'Jeder Quizsatz mit 10 Fragen passt sich basierend auf Ihrer Leistung mithilfe von Spaced Repetition an.',
  speechRate: 'Sprachgeschwindigkeit',
  pitch: 'Tonhöhe',
  volume: 'Lautstärke',
  // Custom Word Input
  enterCustomWord: 'Benutzerdefiniertes Wort eingeben',
  enterYourWordOrPhrase: 'Geben Sie Ihr Wort oder Ihre Phrase ein...',
  useThisWord: 'Dieses Wort verwenden',
  // WordDisplay localization
  currentWordLabel: 'Aktuelles Wort',
  customWordLabel: 'Benutzerdefiniert',
  currentWordSpeech: 'Aktuelles Wort ist: {word}',
  difficultyLabels: {
    easy: 'Einfach',
    medium: 'Mittel',
    hard: 'Schwierig',
  },
  categoryLabels: {
    animals: 'Tiere',
    places: 'Orte',
    nature: 'Natur',
    technology: 'Technologie',
    home: 'Zuhause',
    objects: 'Objekte',
    transport: 'Transport',
  },
  // NATO Input specific translations
  natoInputTitle: 'Ihre NATO-Alphabet-Eingabe',
  natoInputPlaceholder: 'NATO-Wörter eingeben: "Alpha Bravo Charlie..."',
  natoInputListening: 'Zuhören...',
  natoInputLiveScore: 'Live-Punktzahl',

  // Quiz Header translations
  wordQuizInstructions:
    'Konvertieren Sie das Wort unten in das NATO-Alphabet. Sagen Sie jedes NATO-Wort getrennt durch Leerzeichen oder Kommas.',

  // Quiz Actions translations
  retry: 'Wiederholen',
  checkAnswer: 'Antwort prüfen',
  newRandomWord: 'Neues zufälliges Wort',
  cancelCustom: 'Benutzerdefiniert abbrechen',
  customWord: 'Benutzerdefiniertes Wort',

  // Quiz Results translations
  perfect: 'Perfekt!',
  results: 'Ergebnisse',
  expectedNato: 'Erwartetes NATO:',
  play: 'Abspielen',
  letterByLetter: 'Buchstabe für Buchstabe:',
};
